'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// styled


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _getNested = require('get-nested');

var _getNested2 = _interopRequireDefault(_getNested);

var _WizardProgress = require('./WizardProgress');

var _WizardProgress2 = _interopRequireDefault(_WizardProgress);

var _Fieldset = require('../Fieldset');

var _Fieldset2 = _interopRequireDefault(_Fieldset);

var _BaseButton = require('../BaseButton');

var _BaseButton2 = _interopRequireDefault(_BaseButton);

var _SubmitButton = require('../SubmitButton');

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

var _WebformElement = require('../WebformElement');

var _WebformElement2 = _interopRequireDefault(_WebformElement);

var _Webform = require('../Webform');

var _Webform2 = _interopRequireDefault(_Webform);

var _Form = require('../Observables/Form');

var _Form2 = _interopRequireDefault(_Form);

var _buttonWrapper = require('./styled/button-wrapper');

var _buttonWrapper2 = _interopRequireDefault(_buttonWrapper);

var _buttonNext = require('./styled/button-next');

var _buttonNext2 = _interopRequireDefault(_buttonNext);

var _buttonPrev = require('./styled/button-prev');

var _buttonPrev2 = _interopRequireDefault(_buttonPrev);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WizardPages = (_dec = (0, _mobxReact.inject)('submit', 'webform'), _dec(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(WizardPages, _Component);

  function WizardPages() {
    (0, _classCallCheck3.default)(this, WizardPages);
    return (0, _possibleConstructorReturn3.default)(this, (WizardPages.__proto__ || (0, _getPrototypeOf2.default)(WizardPages)).apply(this, arguments));
  }

  (0, _createClass3.default)(WizardPages, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.webform.onSubmitOverwrite = function () {
        if (_this2.props.formStore.page === _this2.props.field.composite_elements[_this2.props.field.composite_elements.length - 1]['#webform_key']) {
          return true; // Execute normal onSubmit
        }

        _this2.navigateToNextPage();
        return false;
      };
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      delete this.props.webform.onSubmitOverwrite;
    }
  }, {
    key: 'changePage',
    value: function changePage(shift) {
      var _this3 = this;

      var pages = this.props.field.composite_elements;
      var pageI = pages.indexOf(pages.find(function (p) {
        return _this3.props.formStore.page === p['#webform_key'];
      }));
      var newPageI = pageI + shift;
      this.props.formStore.page = this.props.field.composite_elements[newPageI]['#webform_key'];
    }
  }, {
    key: 'navigateToNextPage',
    value: function navigateToNextPage() {
      var _this4 = this;

      // Make sure all errors are shown of visible fields.
      this.props.formStore.visibleFieldsOfCurrentPage.forEach(function (field) {
        return field.isBlurred = true;
      });

      // Check if all fields are valid.
      if (this.props.formStore.visibleFieldsOfCurrentPage.every(function (field) {
        return field.valid;
      })) {
        // If all valid, change the page.
        this.changePage(+1);

        // If draft_auto_save is on, submit the page.
        if ((0, _getNested2.default)(function () {
          return _this4.props.form.settings.draft_auto_save;
        })) {
          this.props.submit({
            in_draft: true
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var pages = this.props.field.composite_elements;
      var pageI = pages.indexOf(pages.find(function (p) {
        return _this5.props.formStore.page === p['#webform_key'];
      }));

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_WizardProgress2.default, { pages: pages, currentPage: pageI }),
        pages.map(function (page) {
          return _react2.default.createElement(_Fieldset2.default, (0, _extends3.default)({}, _this5.props, {
            key: page['#webform_key'],
            field: page,
            style: { display: page['#webform_key'] === _this5.props.formStore.page ? null : 'none' },
            form: _this5.props.form,
            webformPage: page['#webform_key'],
            webformElement: _this5.props.webformElement,
            onChange: _this5.props.onChange,
            onBlur: _this5.props.onBlur,
            settings: _this5.props.settings,
            webformSettings: _this5.props.webformSettings,
            status: _this5.props.status
          }));
        }),
        _react2.default.createElement(
          _buttonWrapper2.default,
          null,
          _react2.default.createElement(
            _buttonPrev2.default,
            null,
            _react2.default.createElement(_BaseButton2.default, {
              onClick: function onClick(e) {
                e.preventDefault();_this5.changePage(-1);
              },
              disabled: this.props.formStore.page === pages[0]['#webform_key'],
              label: (0, _getNested2.default)(function () {
                return pages[pageI]['#prev_button_label'];
              }) || (0, _getNested2.default)(function () {
                return _this5.props.form.settings.wizard_prev_button_label;
              }) || 'Previous page',
              primary: false
            })
          ),
          _react2.default.createElement(
            _buttonNext2.default,
            null,
            this.props.formStore.page === pages[pages.length - 1]['#webform_key'] ? _react2.default.createElement(_SubmitButton2.default, {
              form: this.props.form,
              formStore: this.props.formStore,
              status: this.props.status,
              field: this.props.form.elements.find(function (element) {
                return element['#type'] === 'webform_actions';
              }),
              show: true
            }) : _react2.default.createElement(_BaseButton2.default, {
              label: (0, _getNested2.default)(function () {
                return pages[pageI]['#next_button_label'];
              }) || (0, _getNested2.default)(function () {
                return _this5.props.form.settings.wizard_next_button_label;
              }) || 'Next page',
              type: 'submit'
            })
          )
        )
      );
    }
  }]);
  return WizardPages;
}(_react.Component), _class2.propTypes = {
  field: _propTypes2.default.shape({
    composite_elements: _propTypes2.default.arrayOf(_propTypes2.default.shape()).isRequired
  }).isRequired,
  form: _propTypes2.default.shape().isRequired,
  status: _propTypes2.default.string.isRequired,
  formStore: _propTypes2.default.instanceOf(_Form2.default).isRequired,
  submit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  settings: _propTypes2.default.shape({
    custom_elements: _propTypes2.default.shape({
      patternError: _propTypes2.default.shape({
        '#default_value': _propTypes2.default.string,
        '#options': _propTypes2.default.objectOf(_propTypes2.default.string)
      })
    })
  }).isRequired,
  webform: _propTypes2.default.instanceOf(_Webform2.default).isRequired,
  webformSettings: _propTypes2.default.shape().isRequired,
  webformElement: _propTypes2.default.instanceOf(_WebformElement2.default).isRequired
}, _class2.defaultProps = {
  onChange: function onChange() {},
  onBlur: function onBlur() {}
}, _temp)) || _class) || _class);
exports.default = WizardPages;